<template lang="pug">
#detalhamento-analise
    BaseHeader#exportar-relatorio(
        :titulo='dadosCertificacao.dadosTerritorio[0].nomeTerritorio.toUpperCase()',
        icon='el-icon-download',
        btnTexto='Exportar relatório',
        @btnHeaderClicado='handleBtnHeaderClicado',
        :componenteAuxiliarBotaoHeader='"DropdownOptionsExportarRelatorio"',
        :showComponenteAuxiliar='showComponenteAuxiliar',
        :exibeBotao='true',
        voltarPara='emit',
        @voltarClicado='goToGestaoCertificacao()'
    )

    .view-container.margen-bottom-pages
        .bloco-conteudo
            BlocoDadosCertificacao(:dadosCertificacao='dadosCertificacao')

        .bloco-certificacao-territorio
            BlocoCertificacaoTerritorio(:dadosCertificacao='dadosCertificacao')

        .bloco-status-tipo-certificacao
            BlocoStatusCertificacoes(:dadosCertificacao='dadosCertificacao')

        .bloco-conteudo
            .erro(v-if='erroMessage')
                span {{ erroMessage }}
            BlocoDadosAreaPlantio(:dadosAreaPlantio='dadosAreaPlantio')

        .bloco-conteudo
            BlocoDadosCar(
                :dadosTerritorio='dadosTerritorio || {}',
                :arquivosCertificacao='dadosCertificacao?.consolidadoTerritorio?.arquivosCertificacaoTerritorio || []',
                :dadosCertificacao='dadosCertificacao'
            )
        .bloco-conteudo
            HistoricoCertificacao(
                :idAnalise='dadosCertificacao.id',
                :historico='dadosCertificacao.resumoHistoricoCertificacaoTerritorio',
                @atualizar='atualizarDadosPorHistorico'
            )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import BlocoDadosCertificacao from '@/components/certificacao/BlocoDadosCertificacao.vue';
import BlocoStatusCertificacoes from '@/components/certificacao/BlocoStatusCertificacoes.vue';
import BlocoDadosAreaPlantio from '@/components/certificacao/BlocoDadosAreaPlantio.vue';
import CertificacaoService from '@/services/CertificacaoService.js';
import BlocoDadosCar from '@/components/certificacao/BlocoDadosCar.vue';
import BlocoCertificacaoTerritorio from '@/components/certificacao/BlocoCertificacaoTerritorio.vue';
import HistoricoCertificacao from '@/components/certificacao/HistoricoCertificacao.vue';

export default {
    name: 'DetalhamentoAnalise',
    components: {
        BaseHeader,
        BlocoDadosCertificacao,
        BlocoStatusCertificacoes,
        BlocoDadosCar,
        BlocoDadosAreaPlantio,
        BlocoCertificacaoTerritorio,
        HistoricoCertificacao
    },
    data() {
        return {
            dadosCertificacao: {
                id: null,
                dataAnalise: '',
                dadosTerritorio: [
                    {
                        nomeTerritorio: '',
                        municipioTerritorioNome: '',
                        estadoTerritorioSigla: ''
                    }
                ],
                representantes: [],
                cars: [],
                certificacaoTerritorioResultado: [],
                resumoHistoricoCertificacaoTerritorio: []
            },
            dadosTerritorio: null,
            dadosAreaPlantio: {},
            showComponenteAuxiliar: false,
            idCertificacao: null,
            erroMessage: null
        };
    },
    async mounted() {
        this.idCertificacao = this.$route.params.idCertificacao;
        await this.buscarDadosAreaPlantio();

        await this.buscarDadosAnalise();
        this.buscarDadosTerritorio();
    },
    methods: {
        atualizarDadosPorHistorico(idAnalise) {
            if (this.idCertificacao !== idAnalise) {
                const currentPath = this.$route.path;
                const newPath = currentPath.replace(/\d+$/, idAnalise);
                const idCertificacao = Number(idAnalise);

                this.$router.replace({
                    name: this.$route.name,
                    params: {
                        ...this.$route.params,
                        path: newPath,
                        idCertificacao
                    }
                });
                this.idCertificacao = idCertificacao;
                this.buscarDadosAnalise().then(() => {
                    document
                        .getElementById('base-header')
                        .scrollIntoView({ behavior: 'smooth' });
                });
            }
        },
        async buscarDadosAnalise() {
            try {
                const { data } =
                    await CertificacaoService.buscarDadosDetalhamentoAnalise(
                        this.idCertificacao
                    );

                this.dadosCertificacao = { ...data.itens[0] };
            } catch (error) {}
        },
        goToGestaoCertificacao() {
            this.$router.push({ name: 'Certificacao' });
        },
        async buscarDadosTerritorio() {
            if (this.dadosCertificacao && this.dadosCertificacao.id) {
                try {
                    const { data } =
                        await CertificacaoService.buscarDadosTerritorio(
                            this.dadosCertificacao.id
                        );
                    this.dadosTerritorio = data;
                } catch {
                    this.$notify.error(
                        'Ocorreu um erro ao buscar os dados do território.'
                    );
                }
            }
        },
        async buscarDadosAreaPlantio() {
            let idCertificacao = this.$route.params.idCertificacao;
            try {
                const { data } =
                    await CertificacaoService.buscarDadosAreaPlantio(
                        idCertificacao
                    );
                this.dadosAreaPlantio = { ...data };
                this.erroMessage = null;
            } catch (error) {
                this.erroMessage =
                    error.response?.data?.message ||
                    'Erro desconhecido ao carregar dados de plantio';
            }
        },
        handleBtnHeaderClicado() {
            this.showComponenteAuxiliar = !this.showComponenteAuxiliar;
        }
    }
};
</script>

<style lang="scss">
#detalhamento-analise {
    .view-container.margen-bottom-pages {
        display: flex;
        flex-direction: column;

        .bloco-conteudo {
            margin-top: 20px;
            display: flex;
            flex-direction: column;
        }
    }
    .bloco-status-tipo-certificacao {
        margin-top: 20px;
    }
}

.erro {
    color: #fff;
    background-color: #e74c3c;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 15px;
    font-weight: bold;
}
</style>
